import { useState } from "react";
import { Form, Row } from 'react-bootstrap';
import styled from 'styled-components';
import { RiSearch2Line } from 'react-icons/ri';
import { CustomSelect } from 'components/CustomForm';

const Holder = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-right: 1rem;
`;

const VDivider = styled.div`
	width: 1px;
    height: 5rem;
	background-color: #C6C6C6;
`;

const Label = styled.span`
    text-align: center;
`;

const UsersTabMenu = ({tabData}) => {
    const getInputsCount = () => `${tabData?.sum ?? 0}`.persianCurrency();
    const getTypesCount = () => `${tabData?.count ?? 0}`.persianCurrency();

    return (
        <Holder>
            <Label>تعداد شرکت های ثبت شده  : {getInputsCount()} شرکت</Label>
            <VDivider />
            <Label>تعداد کاربران ثبت شده  : {getTypesCount()} کاربر</Label>
        </Holder>
    );
};

export default UsersTabMenu;